const dataExtension = {
  lookback: 30,
  emailType: 'all_emails',
  eventType: 'open',
  undersaturated: 10,
  oversaturated: 48
};

export default dataExtension;
